import { motion } from "framer-motion";
import { Award, Star } from "lucide-react";
import { IMAGES, T } from "../data/content";
import { useLang } from "../context/LangContext";

export const Awards = () => {
  const { tr } = useLang();
  return (
    <section className="relative overflow-hidden bg-[#0C0806] py-20 lg:py-28" data-testid="awards-section">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-7"
          >
            <div className="mb-6 flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-4 py-1.5 text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">
                <Award className="h-3.5 w-3.5" /> {tr(T.awards.nominee)}
              </span>
              <span className="inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-1.5 text-[10px] uppercase tracking-[0.25em] text-[#D9CFB9]">
                {tr(T.awards.years)}
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full border border-white/15 px-4 py-1.5 text-[10px] uppercase tracking-[0.25em] text-[#D9CFB9]">
                <Star className="h-3.5 w-3.5 fill-[#D4AF37] text-[#D4AF37]" /> {tr(T.awards.rating)}
              </span>
            </div>
            <h2 className="font-serif text-4xl leading-[1.05] tracking-tight text-[#F5ECDA] md:text-5xl">
              {tr(T.awards.title)}
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-[#B7A78C]">{tr(T.awards.sub)}</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="lg:col-span-5"
          >
            <div className="relative mx-auto max-w-[340px]">
              <div className="absolute -inset-4 rounded-sm bg-[#D4AF37]/10 blur-2xl" />
              {/* Framed certificate */}
              <div className="relative rounded-[3px] bg-gradient-to-br from-[#E7C766] via-[#B8860B] to-[#8a651a] p-[5px] shadow-[0_30px_60px_-15px_rgba(0,0,0,0.7)]">
                <div className="rounded-[2px] border border-[#5c4410]/40 p-[2px]">
                  <div className="rounded-[2px] bg-[#F5ECDA] p-2.5">
                    <div className="overflow-hidden border border-[#D4AF37]/50">
                      <img
                        src={IMAGES.studio.award}
                        alt="London Retail Business Awards 2026 Nominee — Best Beauty Salon"
                        className="block aspect-[3/4] w-full rotate-[3deg] scale-[1.12] object-cover object-[62%_30%]"
                        data-testid="award-letter-image"
                      />
                    </div>
                    <div className="mt-2.5 flex items-center justify-center gap-2">
                      <span className="h-px w-6 bg-[#B8860B]/60" />
                      <span className="font-serif text-[11px] italic tracking-wide text-[#6b5220]">Best Beauty Salon · 2026</span>
                      <span className="h-px w-6 bg-[#B8860B]/60" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
